import * as Types from './userActionTypes.js'

const initialState = {
    userToken: '',
    userInfo: '',
    isAdministrator: false,
    isPloegchef: false
};

export default function user(state = initialState, action) {
    switch (action.type) {
        case Types.SET_USERTOKEN:
            if (state.userToken !== action.userToken) {
                return Object.assign({}, state, { userToken: action.userToken });
            }
            return state;
        case Types.SET_USERINFO:
            if (state.userInfo !== action.userInfo) {
                if(action.userInfo.role !== undefined && action.userInfo.role !== null){
                    if (action.userInfo.role.includes("Administrator")) {
                        if(!state.isAdministrator){
                            state.isAdministrator = true
                        }
                    }
                    if (action.userInfo.role.includes("Ploegchef")) {
                        if(!state.isPloegchef){
                            state.isPloegchef = true
                        }
                    }
                }               
                return Object.assign({}, state, { userInfo: action.userInfo });
            }

            return state;
        default:
            return state;
    }
}